import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore } from "redux-persist";
import RootReducer from "./RootReducer";
import logger from "redux-logger"

const reduxStore = createStore(RootReducer, applyMiddleware(thunk));
const persistor = persistStore(reduxStore);

export { reduxStore, persistor };
